import { Capacitor } from '@capacitor/core';
import { isAndroid } from '~common/device';

let cachedAndroidVersion: number | null | undefined = undefined;

export async function getAndroidVersion(): Promise<number | null> {
  if (cachedAndroidVersion !== undefined) {
    return cachedAndroidVersion;
  }

  if (!Capacitor.isNativePlatform() || !isAndroid()) {
    cachedAndroidVersion = null;
    return null;
  }

  try {
    const { Device } = await import('@capacitor/device');
    const deviceInfo = await Device.getInfo();
    const osVersion = deviceInfo.osVersion;

    const versionParts = osVersion.split('.');
    if (versionParts.length === 0) {
      cachedAndroidVersion = null;
      return null;
    }
    const majorVersion = parseInt(versionParts[0], 10);
    if (isNaN(majorVersion)) {
      cachedAndroidVersion = null;
      return null;
    }

    cachedAndroidVersion = majorVersion;
    return majorVersion;
  } catch (error) {
    console.warn('[SafeArea] Failed to get Android version:', error);
    cachedAndroidVersion = null;
    return null;
  }
}
